import { HeadProvider, Title } from 'react-head';

import { translation, TranslatedComponent } from '@hh.ru/front-static-app';

import { useSelector } from 'src/modules/useSelector';

const TrlKeys = {
    error: {
        '400': 'error.400.message',
        '403': 'error.403.message',
        '404': 'error.404.message',
        '500': 'error.500.tryAgain',
        '599': 'error.599.tryAgain',
    },
};

const PageErrorWrapper: TranslatedComponent = ({ children, trls }) => {
    const errorCode = useSelector((state) => state.errorCode);
    if (errorCode) {
        const trl = trls[TrlKeys.error[errorCode]];
        const headTags = [<Title key="title">{trl}</Title>];
        return (
            <>
                <HeadProvider headTags={headTags}>{headTags.map((headTag) => headTag)}</HeadProvider>
                {children}
            </>
        );
    }

    return <>{children}</>;
};

export default translation(PageErrorWrapper);
